export const unHttp = [
    "https://g.cn.miaozhen.com",
    "https://e.cn.miaozhen.com",
    "https://i.gridsumdissector.com/v",
    "https://c.gridsumdissector.com/r",
    "https://impression.aflink.com",
    "https://app.aflink.com",
    "https://public.yiye.ai",
    "https://ef-dongfeng.tanx.com",
    "https://s2s.adjust.com",
    "https://s2s.adjust.com/impression",
    "https://view.adjust.com/impression",
    "https://app.adjust.com",
    "https://trace.rtbasia.com",
    "https://bv.lnk0.com",
    "https://b.lnk0.com",
    "https://fireclick.jd.com",
    "https://im-x.jd.com",
    "https://ccc-x.jd.com",
    "https://dmp-data.vip.com",
    "https://gh.baidu.com",
    "https://ug.baidu.com",
    "https://qqcallback.api.weibo.cn",
    "https://push.bigda.com/",
    "https://gungnir.xiaojukeji.com",
    "https://dcs.ipinyou.com",
    "https://123.com",
    "https://ad.doubleclick.net/ddm/trackimp",
    "https://ad.doubleclick.net/ddm/trackclk",
    "https://m.ctrmi.cn",
    "https://105C300002-0.m.ctrmi.cn",
    "https://105C300001-0.m.ctrmi.cn",
    "https://105C300003-0.m.ctrmi.cn",
    "https://105C300001-1.m.ctrmi.cn",
    "https://105C300002-1.m.ctrmi.cn",
    "https://105C300003-1.m.ctrmi.cn",
    "https://e.uril6.com",
    "https://impressions.onelink.me",
    "https://grabcn.onelnk.com",
    "https://appnew.ly.com",
    "https://st.soyoung.com",
    "https://m.ctrip.com/",
    "https://stats.dmp.ghac.cn",
    "https://trk.changan.com.cn",
    "https://g.dtv.cn.miaozhen.com/",
    "https://ad.shuguaiguai.com/",
    "https://1088700001-1.m.ctrmi.cn",
    "https://1088700001-0.m.ctrmi.cn",
    "https://uri6.com/tkio/FjuuMra?noredirect=true",
    "https://ym.57zhe.com",
    "https://1093F00001-0.m.ctrmi.cn",
    "https://1093F00001-1.m.ctrmi.cn",
    "https://api.guangjiubusiness.com",
    "https://lanyikj-api.mbimc.com",
    "https://uri6.com",
    "https://ads.serving-sys.cn",
    "https://api.xahc971.com",
    "https://api.iegadp.qq.com",
    "https://www.xiaohongshu.com",
    "https://datapost.biliapi.com",
    "https://dmp.365dmp.com",
    "https://mm4.365dmp.com",
    "https://mm1.365dmp.com",
    "https://mm2.365dmp.com",
    "https://mm3.365dmp.com",
    "https://vt.ipinyou.com",
    "https://lnk0.com",
    "https://api.ofgame.net",
    "https://10BAD00020-0.m.ctrmi.cn",
    "https://10BAD00020-1.m.ctrmi.cn",
    "https://10BAD00021-0.m.ctrmi.cn",
    "https://10BAD00022-0.m.ctrmi.cn",
    "https://10BAD00021-1.m.ctrmi.cn",
    "https://10BAD00022-1.m.ctrmi.cn",
    "https://sapi.tianjinzhaofa.cn",
    "https://click.yingzhongshare.com/",
    "https://v4m.youzu.com",
    "https://mim-x.jd.com",
    "https://uri6.com/tkio/6V3EFja?noredirect=true",
    "https://callback.api.xyzggg.com",
    "https://g.dtv.cn.miaozhen.com",
    "https://quickapi.edyunyddc13.cn",
    "https://source.jinanchuanjie.cn",
    "https://sunny.careduka.com/",
    "https://10D3A00001-0.m.ctrmi.cn",
    "https://10D3A00001-1.m.ctrmi.cn",
    "https://10DC100001-0.m.ctrmi.cn",
    "https://10DC100002-0.m.ctrmi.cn",
    "https://10DC100001-1.m.ctrmi.cn",
    "https://10DC100002-1.m.ctrmi.cn",
    "https://apimobile.meituan.com",
    "https://source.riverlimittech.net",
    "https://mapitd.yiche.com",
    "https://source.blossomroll.cn",
    "https://sempage.guazi.com",
    "https://daoximgwang.cn",
    "https://rpclusters.cn-beijing.log.aliyuncs.com",
    "https://apis.xayabx.com",
    "https://monitor.blossomroll.cn",
    "https://sat-b0.sensorsdata.cn",
    "https://pub.funshion.com",
    "https://devtper.51job.com",
    "https://qatper.51job.com",
    "https://tper.51job.com",
    "https://source.secureqin.net",
    "https://source.diamondfavour.net/",
    "https://prta.zhaopin.com",
    "https://10EF700001-0.m.ctrmi.cn",
    "https://10EF700002-0.m.ctrmi.cn",
    "https://10EF500001-0.m.ctrmi.cn",
    "https://10EF500002-0.m.ctrmi.cn",
    "https://10EF700001-1.m.ctrmi.cn",
    "https://10EF700002-1.m.ctrmi.cn",
    "https://10EF500001-1.m.ctrmi.cn",
    "https://10EF500002-1.m.ctrmi.cn",
    "https://t.in-neo.cn/dar",
    "https://t.in-neo.cn",
    "https://10F2F00001-0.m.ctrmi.cn",
    "https://10F2F00001-1.m.ctrmi.cn",
    "https://mdcsfback.huidu001.com/",
    "https://ad.doubleclick.net",
    "https://10FC700001-0.m.ctrmi.cn",
    "https://10FC700001-1.m.ctrmi.cn",
    "https://10FC700002-1.m.ctrmi.cn",
    "https://api.jiakao.qwdata.vip",
    "https://api.leaping.games/",
    "https://api.leaping.games",
    "https://ad.openinstall.io",
    "https://bv.brg0.com",
    "https://1107E0000B-0.m.ctrmi.cn",
    "https://1107E0000C-0.m.ctrmi.cn",
    "https://1107E0000B-1.m.ctrmi.cn",
    "https://1107E0000D-0.m.ctrmi.cn",
    "https://1107E0000C-1.m.ctrmi.cn",
    "https://1107E0000D-1.m.ctrmi.cn",
    "https://ocpx.mktad.cn/ocpx/router/V100/monitor",
    "https://1119A00001-0.m.ctrmi.cn",
    "https://1119A00001-1.m.ctrmi.cn",
    "https://1119B00001-0.m.ctrmi.cn",
    "https://1119B00001-1.m.ctrmi.cn",
    "https://111B100001-0.m.ctrmi.cn",
    "https://111B100001-1.m.ctrmi.cn",
    "https://111B300001-0.m.ctrmi.cn",
    "https://111B300001-1.m.ctrmi.cn",
    "https://111B400001-0.m.ctrmi.cn",
    "https://111B400001-1.m.ctrmi.cn",
    "https://111CE00001-0.m.ctrmi.cn",
    "https://111CE00001-1.m.ctrmi.cn",
    "https://111E100001-0.m.ctrmi.cn",
    "https://111E100001-1.m.ctrmi.cn",
    "https://m.airchina.com.cn",
    "https://m.airchina.com",
    "https://airchina.com",
    "https://airchina.cn",
    "https://eap.alipay.com",
    "https://tkio-redirect.solar-engine.com",
    "https://m.airchina.com.cn/activity/20241126133135/ghbyzsh5/ghbyzsh5.html?utm_medium=display&utm_source=huawei_MO&utm_campaign=2024NOV022_20241228&utm_content=CHN_pic_FEEDS&utm_term=huitong_-",
    "https://eq.10jqka.com.cn",
    "https://wcp.taobao.com",
    "https://111CE00002-0.m.ctrmi.cn",
    "https://111CE00002-1.m.ctrmi.cn",
    "https://ad-click.whmwan.com/",
    "https://open.snssdk.com",
    "https://1134400001-0.m.ctrmi.cn",
    "https://1134400001-1.m.ctrmi.cn",
    "https://api.k.sohu.com",
    "https://at.umtrack.com",
    "https://gxbr.cnzz.com",
    "https://113AB00001-0.m.ctrmi.cn",
    "https://113AB00001-1.m.ctrmi.cn",
    "https://adclick.kg.qq.com",
    "https://backend.gravity-engine.com",
    "https://www.turkishairlines.com",
    "https://h5.kugou.com",
    "https://v2.reachmax.cn",
    "https://ugapi.alipay.com",
    "https://volctrack.com",
    "https://media-ad.gxwenyutech.com",
    "https://collect.whyaoyuan.cn",
    "https://toufang.huixuanjiasu.com",
    "https://integralwall.baidu.com",
    "https://99uri.com",
    "https://snssdk.com",
    "https://114D400001-0.m.ctrmi.cn",
    "https://114D400001-1.m.ctrmi.cn",
    "https://delivery-data.dewu.com",
    "https://channel.m.163.com",
    "https://adapi.sh9130.com",
    "https://admfb-api.zkyouxi.com",
    "https://promotion-partner.kuaishou.com/",
    "https://ad.ketai888.cn/",
    "https://www.minigame.xy.com",
    "https://qbugreport.html5.qq.com",
    "https://click.yingzhongshare.com",
    "https://1177500001-0.m.ctrmi.cn",
    "https://1177500001-1.m.ctrmi.cn",
    "https://1177500002-0.m.ctrmi.cn",
    "https://1177500002-1.m.ctrmi.cn",
    "https://1177500003-0.m.ctrmi.cn",
    "https://1177500003-1.m.ctrmi.cn",
    "https://1187F00001-0.m.ctrmi.cn",
    "https://1187F00001-1.m.ctrmi.cn",
    "https://ad-center.huajiao.com",
    "https://amap-ocpx-online.amap.com",
    "https://integralwall.baidu.com/",
    "https://11AC600001-0.m.ctrmi.cn",
    "https://11AC600001-1.m.ctrmi.cn"
]